"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var CONTAINER_STYLES = "flex flex-col shadow absolute bg-white rounded py-2";
/**
 * A context menu with overlay to dismiss itself when a user clicks outside of
 * the menu. Similar to a modal view but purely for menu navigation.
 */
exports.ContextMenuContainer = react_1.default.forwardRef(function (_a, forwardRef) {
    var className = _a.className, style = _a.style, children = _a.children, handleClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: handleClick, className: (0, clsx_1.default)(CONTAINER_STYLES, className), style: style, ref: forwardRef }, { children: (0, jsx_runtime_1.jsx)("ol", __assign({ className: "flex flex-col" }, { children: children }), void 0) }), void 0));
});
